import { getPricingTimeByIdRequest } from "../../data/pricingTimeApi";

function getPayloadData(response) {
  if (response?.data?.data) {
    return response.data.data;
  }

  if (response?.data) {
    return response.data;
  }

  return response;
}

export async function getPricingTimeByIdUseCase(id) {
  return getPayloadData(await getPricingTimeByIdRequest(id));
}
